export default __webpack_public_path__ + "media/music/84c615354b7ec070f0bf2e31bd20002d.mp3";